import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Linkedin } from "lucide-react";
import { Button } from "@/components/ui/button";

const navLinks = [
{ href: "/", label: "Home" },
{ href: "/about", label: "About" },
{ href: "/skills", label: "Skills" },
{ href: "/lets-talk-ai", label: "Let's Talk AI" },
{ href: "/ai-labs", label: "AI Labs" },
{ href: "/blog", label: "Blog" },
{ href: "/newsletter", label: "Newsletter" }];


export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 glass border-b border-zinc-200/50" data-testid="header">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center" data-testid="logo-link">
            <span className="font-display !font-bold !text-2xl text-zinc-950">VASANTH NATARAJAN

            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8" data-testid="desktop-nav">
            {navLinks.map((link) =>
            <Link
              key={link.href}
              to={link.href}
              className={`nav-link text-sm font-medium tracking-wide transition-colors ${
              location.pathname === link.href ?
              "text-royal-blue-800" :
              "text-zinc-600 hover:text-zinc-950"}`
              }
              data-testid={`nav-link-${link.label.toLowerCase()}`}>

                {link.label}
              </Link>
            )}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden lg:flex items-center gap-4">
            <a
              href="https://www.linkedin.com/in/vasan-natarajan"
              target="_blank"
              rel="noopener noreferrer"
              className="text-zinc-600 hover:text-royal-blue-800 transition-colors"
              data-testid="linkedin-link">

              <Linkedin size={20} />
            </a>
            <Link to="/contact">
              <Button
                className="bg-royal-blue-800 hover:bg-royal-blue-700 text-white text-xs tracking-wider uppercase px-6 py-5"
                data-testid="header-cta">

                Get in Touch
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 text-zinc-950"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-toggle">

            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen &&
      <div className="lg:hidden mobile-menu border-t border-zinc-200" data-testid="mobile-menu">
          <nav className="flex flex-col px-6 py-6 space-y-4">
            {navLinks.map((link) =>
          <Link
            key={link.href}
            to={link.href}
            className={`text-base font-medium py-2 ${
            location.pathname === link.href ?
            "text-royal-blue-800" :
            "text-zinc-600"}`
            }
            onClick={() => setMobileMenuOpen(false)}
            data-testid={`mobile-nav-${link.label.toLowerCase()}`}>

                {link.label}
              </Link>
          )}
            <div className="pt-4 border-t border-zinc-200">
              <Link to="/contact" onClick={() => setMobileMenuOpen(false)}>
                <Button className="w-full bg-royal-blue-800 hover:bg-royal-blue-700 text-white">
                  Get in Touch
                </Button>
              </Link>
            </div>
          </nav>
        </div>
      }
    </header>);

}